const API_BASE = (import.meta as any).env?.VITE_API_BASE ?? 'https://app-xyqar-api.azurewebsites.net';
export { API_BASE };
export async function apiGet<T = any>(p: string, t?: string): Promise<T> {
  const r = await fetch(`${API_BASE}${p}`, { headers: t ? { Authorization: `Bearer ${t}` } : {} });
  if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json();
}
export async function apiPost<T = any>(p: string, body: any, t?: string): Promise<T> {
  const r = await fetch(`${API_BASE}${p}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(t ? { Authorization: `Bearer ${t}` } : {}) },
    body: JSON.stringify(body ?? {}),
  });
  if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json().catch(() => ({} as T));
}
